<template>
  <div v-if="basicDetails" class="class-detail-page">
    <vx-card title="Class Details - ">
      <h4 class="class-name">
        <b>{{ basicDetails.name }}</b>
      </h4>
      <div class="flex flex-wrap">
        <div class="md:w-1/4 w-full">
          <img
            :src="
              basicDetails.file
                ? basicDetails.file.file_path
                : basicDetails.class_default_image
            "
            alt="class_image"
            class="w-full"
          />
        </div>
        <div class="md:w-3/4 w-full px-5 py-3">
          <span>Class Description: </span>
          <span>{{ basicDetails.description }}</span>
        </div>
        <vs-row class="main-info">
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-1 sm:pl-3"
          >
            <img
              :src="
                basicDetails.class_teacher_details.picture
                  ? basicDetails.class_teacher_details.picture
                  : 'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'
              "
              alt="mainInfoItemImage"
              class="main-info-item-image"
            />
            <div class="main-info-item-text">
              <span class="first-line">{{
                basicDetails.class_teacher_name
              }}</span>
              <span class="second-line">Class Teacher</span>
            </div>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-1 sm:pl-3"
          >
            <feather-icon icon="CalendarIcon" class="main-info-item-icon" />
            <div class="main-info-item-text">
              <span class="first-line">{{
                basicDetails.student.student_details.length
              }}</span>
              <span class="second-line">Number of students</span>
            </div>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-1 sm:pl-3"
          >
            <feather-icon icon="MapPinIcon" class="main-info-item-icon" />
            <div class="main-info-item-text">
              <span class="first-line">{{
                basicDetails.asset_name || '-'
              }}</span>
              <span class="second-line">Room</span>
            </div>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-1 sm:pl-3"
          >
            <img
              :src="require('@/assets/images/start-date-img.svg')"
              alt="startDateImg"
              class="main-info-item-icon"
            />
            <div class="main-info-item-text">
              <span class="first-line">{{
                basicDetails.start_date | dateFormatLocalization
              }}</span>
              <span class="second-line">Start Date</span>
            </div>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-1 sm:pl-3"
          >
            <img
              :src="require('@/assets/images/end-date-img.svg')"
              alt="endDateImg"
              class="main-info-item-icon"
            />
            <div class="main-info-item-text">
              <span class="first-line">{{
                basicDetails.end_date | dateFormatLocalization
              }}</span>
              <span class="second-line">End Date</span>
            </div>
          </vs-col>
          <vs-col
            ref="class_student_img_holder"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="2"
            class="p-4 sm:p-2 class_student_img_holder horizontal_scrollbar"
            style="position: relative"
          >
            <template v-for="(
                  student, index
                ) in basicDetails.student.student_details.slice(0, 5)">
              <vs-tooltip :text="`${student.first_name} ${student.middle_name} ${student.last_name}`" color="primary" :key="index" :style="`left: ${15 * (index + 1)}px`" style="position: absolute;" class="main-info-item-image overlap-image">
                <img
                  :key="index"
                  :src="
                    student.picture
                      ? student.picture
                      : 'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'
                  "
                  alt="mainInfoItemImage"
                  style="width: 100%; border-radius: 100%;"
                />
              </vs-tooltip>
            </template>
            <strong v-if="basicDetails.student.student_details.slice(0, 5).length - 2 > 2" @click="showMore" class="more_holder click_holder">+{{ basicDetails.student.student_details.slice(0, 5).length - 2 }} More</strong>
            <strong :style="`padding-left: ${basicDetails.student.student_details.slice(0, 5).length * 20}px`" class="less_holder click_holder" @click="showLess">Show Less</strong>
          </vs-col>
        </vs-row>
      </div>
    </vx-card>

    <div class="other-info">
      <vs-tabs>
        <vs-tab label="Students">
          <div class="flex flex-1 justify-end p-4">
            <vs-button
              v-if="checkEditPermission() && !isArchived"
              type="border"
              class="includeIcon includeIconOnly ml-3"
              icon-pack="feather"
              icon="icon-edit"
              @click="openAssignedStudentsEditModal"
            ></vs-button>
          </div>
          <div class="flex flex-1 flex-col">
            <ag-grid-vue
              ref="agGridTable"
              class="ag-theme-material w-100 mb-4 ag-grid-table"
              :style="{
                minHeight: selected_students_list.length * 48 + 75 + 'px'
              }"
              :gridOptions="gridOptions1"
              :animateRows="true"
              :floatingFilter="false"
              :suppressPaginationPanel="true"
              :enableRtl="$vs.rtl"
              :columnDefs="selectedStudentsListColumnDefs"
              :rowData="selected_students_list"
              @grid-ready="onGridReady1"
            />
          </div>
        </vs-tab>
        <vs-tab label="Teachers">
          <div class="flex flex-1 justify-end p-4">
            <vs-button
              v-if="checkEditPermission() && !isArchived"
              type="border"
              class="includeIcon includeIconOnly ml-3"
              icon-pack="feather"
              icon="icon-edit"
              @click="openAssignedTeachersEditModal"
            ></vs-button>
          </div>
          <div class="flex flex-1 flex-col">
            <ag-grid-vue
              ref="agGridTable"
              class="ag-theme-material w-100 mb-4 ag-grid-table"
              :style="{
                minHeight: selected_teachers_list.length * 48 + 75 + 'px'
              }"
              :gridOptions="gridOptions"
              :animateRows="true"
              :floatingFilter="false"
              :suppressPaginationPanel="true"
              :enableRtl="$vs.rtl"
              :columnDefs="selectedTeachersListColumnDefs"
              :rowData="selected_teachers_list"
              @grid-ready="onGridReady"
            />
          </div>
        </vs-tab>
        <vs-tab label="Class Curriculum">
          <div class="flex flex-1 justify-end p-4">
            <vs-button
              v-if="
                checkEditPermission() && !isArchived && showClassCurriculumImport
              "
              class="primary imp_btn"
              @click="openImportAssignment()"
              >Import</vs-button
            >
          </div>
          <vs-tabs>
            <vs-tab label="Homework" @click="assignmentType('homework')">
              <AssignmentList
                :assignment_data_list="assignment_data_list"
                @deleteCurricullum="deleteCurricullum"
                :edit_permission="allowedToDelete"
              ></AssignmentList>
            </vs-tab>

            <vs-tab
              label="Exam"
              @deleteCurricullum="deleteCurricullum"
              @click="assignmentType('exam')"
            >
              <AssignmentList
                :assignment_data_list="assignment_data_list"
                @deleteCurricullum="deleteCurricullum"
                :edit_permission="allowedToDelete"
              ></AssignmentList>
            </vs-tab>

            <vs-tab label="Lesson" @click="assignmentType('lesson')">
              <LessonListing
                :assignment_data_list="assignment_data_list"
                @deleteCurricullum="deleteCurricullum"
                :edit_permission="allowedToDelete"
              >
              </LessonListing>
            </vs-tab>

            <vs-tab label="Reports" @click="assignmentType('report')">
              <AssignmentList
                :assignment_data_list="assignment_data_list"
                @deleteCurricullum="deleteCurricullum"
                :edit_permission="allowedToDelete"
              ></AssignmentList>
            </vs-tab>

            <vs-tab label="Files" @click="getUploadedFiles">
              <div class="cstm_vuefileagent_holder w-full">
                <file-upload-component
                  @deletedIndex="deleteUploadedFile"
                  @getFileId="getFileId"
                  :file_repository_id="repository_id"
                  :files_info="files_info"
                  :multiple="true"
                  :edit_permission="allowedToEdit"
                ></file-upload-component>
              </div>
              <div class="flex flex-1 justify-end mt-10">
                <vs-button
                  v-if="checkEditPermission() && !isArchived"
                  @click="saveFiles"
                  >Save Files</vs-button
                >
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-tab>
        <vs-tab disabled label="Disabled">
          <div class="tab-text">
            <p>
              Chocolate powder candy canes cake gummies tart donut. Gummi bears
              sesame snaps bonbon apple pie carrot cake croissant marzipan candy
              canes jelly-o. Marshmallow sweet cake gummies ice cream toffee.
              Jelly gingerbread jelly beans tart tart. Jelly-o bonbon jelly-o
              lemon drops sweet roll jujubes cake. Chocolate cake dessert sugar
              plum.
            </p>
            <p class="mt-2">
              Jelly beans brownie chocolate bar. Jujubes lemon drops apple pie
              chocolate cake bear claw cupcake chocolate sweet pastry. Pastry
              carrot cake liquorice. Sesame snaps sugar plum chupa chups
              tiramisu. Halvah cake chocolate bar jelly beans dragée chocolate
              halvah pudding pudding.
            </p>
          </div>
        </vs-tab>
        <vs-tab label="Account">
          <div class="tab-text">
            <p>
              Gingerbread tart marzipan sweet lemon drops wafer soufflé apple
              pie lemon drops. Cake pie apple pie icing fruitcake liquorice
              dessert sugar plum liquorice. Cake liquorice sugar plum cake
              croissant sweet. Jelly beans donut dessert. Cake jelly-o marzipan
              candy canes biscuit jelly toffee. Gummi bears jelly-o pastry
              macaroon gummies gingerbread liquorice bonbon chocolate cake.
            </p>
            <p class="mt-2">
              Dragée muffin lemon drops. Cake sweet tootsie roll cupcake cake
              sugar plum lemon drops. Pudding gingerbread sesame snaps sweet.
              Gummi bears gingerbread pastry cotton candy sesame snaps toffee.
              Cake chocolate bonbon marzipan jelly-o powder. Cupcake jujubes
              fruitcake oat cake powder caramels.
            </p>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>

    <vs-collapse accordion class="class_setting_collapse">
      <vs-collapse-item>
        <div slot="header">
          <h4>Class Settings</h4>
        </div>
        <vs-tabs class="class_setting_tab1">
          <vs-tab label="Schedule Settings">
            <schedule-settings
              :teacher_list="selected_teachers_list"
              :class_id="classId"
              :edit_permission="allowedToEdit"
              @subjects_selected="subjectsSelected"
            />
          </vs-tab>
          <vs-tab label="Certificate Settings">
            <div class="tab-text">
              <!-- {{settings_obj}} -->
              <div class="cstm_vuexy_table">
                <table
                  class="
                    course-table course_type_table
                    default_cursor
                    w-full
                    p-4
                  "
                >
                  <tr>
                    <th style="width: 200px">Template</th>
                    <td style="width: 300px; padding: 0 15px">
                      <vs-button
                        v-if="checkEditPermission() && !isArchived"
                        color="primary"
                        type="filled"
                        @click="template_list = true"
                        >Select Certificate Template</vs-button
                      >
                    </td>
                    <td style="padding: 0">
                      <div
                        v-if="basicDetails.class_certificate_template != null"
                      >
                        <strong
                          style="
                            font-size: 11px;
                            text-transform: uppercase;
                            background: #f3f2f7;
                            padding: 10px 15px;
                          "
                          class="block"
                          >Selected Template Name:
                        </strong>
                        <a
                          style="
                            color: rgba(var(--vs-primary), 1);
                            font-weight: 600;
                            cursor: pointer;
                            padding: 5px 15px;
                          "
                          class="block"
                          @click="
                            handlePreview(
                              basicDetails.class_certificate_template
                            )
                          "
                          >{{
                            basicDetails.class_certificate_template.title
                          }}</a
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th style="width: 200px">Share Options</th>
                    <td colspan="2">
                      <vs-radio
                        v-if="checkEditPermission() && !isArchived"
                        v-model="basicDetails.certificate_share_type"
                        vs-name="certificate_share_type"
                        vs-value="1"
                        >Manual Share</vs-radio
                      >&nbsp;&nbsp;
                      <vs-radio
                        v-if="checkEditPermission() && !isArchived"
                        v-model="basicDetails.certificate_share_type"
                        vs-name="certificate_share_type"
                        vs-value="2"
                        >Share after class end date</vs-radio
                      >
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <vs-button
              v-if="checkEditPermission() && !isArchived"
              color="primary"
              class="items-center mt-4"
              @click="updateCertificate"
              type="filled"
              >Update</vs-button
            >
          </vs-tab>

          <vs-tab label="Chat Settings">
            <ChatSettings
              :chat_settings="chat_settings"
              :class_id="classId"
              :edit_permission="allowedToEdit"
              @on_chat_setting_updated="updateChatSettings"
            />
          </vs-tab>
        </vs-tabs>
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">
          <h4>Attendance</h4>
        </div>
        <vs-tabs>
          <vs-tab label="Student Attendance">
            <StudentAttendance
              :edit_permission="allowedToEdit"
              :is_archived="isArchived"
              :class_id="classId"
            ></StudentAttendance>
          </vs-tab>
          <vs-tab label="Teacher Attendance">
            <TeacherAttendance
              :edit_permission="allowedToEdit"
              :is_archived="isArchived"
              :class_id="classId"
            ></TeacherAttendance>
          </vs-tab>
        </vs-tabs>
      </vs-collapse-item>

      <vs-collapse-item>
        <div slot="header">
          <h4>Grade</h4>
        </div>
        <div class="flex flex-1">
          <vs-tabs class="unique_cstm_tab">
            <vs-tab
              v-if="checkGradebookClassListViewPermission()"
              label="Student Grade List"
            >
              <grade-listing
                :class_id="classId"
                :is_archived="isArchived"
                :edit_permission="allowedToEditMarks"
                :share_permission="checkClassGradebookSharePermission()"
              />
            </vs-tab>
            <vs-tab
              v-if="checkGradebookClassListViewPermission()"
              label="Grade Settings"
            >
              <GradeSettings
                :class_id="classId"
                :edit_permission="allowedToEditGradeSettings"
              />
            </vs-tab>
          </vs-tabs>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <basic-details-edit-modal
      v-if="basicDetailsModalShow"
      :open="basicDetailsModalShow"
      @close="closeBasicDetailsEditModal"
      :basic_details="details_to_edit"
      :id_to_edit="classId"
      @on_data_updated="updateList"
    />

    <assigned-teachers-edit-modal
      v-if="assignedTeachersModalShow"
      :open="assignedTeachersModalShow"
      @close="closeAssignedTeachersEditModal"
      :basic_details="details_to_edit"
      :id_to_edit="classId"
      @on_data_updated="updateList"
    />

    <assigned-students-edit-modal
      v-if="assignedStudentsModalShow"
      :open="assignedStudentsModalShow"
      @close="closeAssignedStudentsEditModal"
      :basic_details="details_to_edit"
      :id_to_edit="classId"
      @on_data_updated="updateList"
    />
    <vs-popup
      class="certificate_preview_popup"
      title="Template List"
      :active.sync="template_list"
    >
      <vs-table class="cstm_vuexy_table" :data="classTempList">
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th style="width: 240px"> Certificate Name </vs-th>
          <vs-th style="width: 325px"> Certificate Description </vs-th>
          <vs-th style="width: 325px">Preview </vs-th>
        </template>
        <template slot-scope="{ data }">
          <template v-for="(tr, indextr) in data">
            <vs-tr
              :data="tr"
              :key="indextr"
              :class="[
                opened.includes(data[indextr].certificate_template_id)
                  ? 'opened'
                  : '',
                basicDetails.certificate_template_id ==
                data[indextr].certificate_template_id
                  ? 'checked'
                  : ''
              ]"
            >
              <vs-td :data="data[indextr]">
                <vs-checkbox
                  :checked="
                    basicDetails.certificate_template_id ==
                    data[indextr].certificate_template_id
                  "
                  @change="handleChange(data[indextr])"
                ></vs-checkbox>
              </vs-td>
              <vs-td :data="data[indextr].title">
                {{ data[indextr].title }}
              </vs-td>
              <vs-td :data="data[indextr].description">
                {{ data[indextr].description }}
              </vs-td>
              <vs-td>
                <div class="flex">
                  <vs-button
                    class="mx-1"
                    icon-pack="feather"
                    @click="preview(data[indextr])"
                    icon="icon-eye"
                    type="filled"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
            <vs-tr
              v-if="opened.includes(data[indextr].certificate_template_id)"
              :key="indextr"
            >
              <vs-td colspan="4">
                <previewTemp :tempDetail="tempDetails"> </previewTemp>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
      <!-- <vs-card v-if="previewModal">
              <previewTemp :tempDetail="tempDetails"> </previewTemp>
              </vs-card>  -->
      <vs-button
        color="primary"
        @click="template_list = false"
        type="filled"
        class="block ml-auto mr-4 my-4"
        >Save</vs-button
      >
    </vs-popup>
    <vs-popup
      class="certificate_preview_popup"
      title="Selected Certificate Template Preview"
      :active.sync="previewSelectCerModal"
    >
      <div v-if="previewSelectCerModal">
        <previewTemp :tempDetail="SelectTempDetails"> </previewTemp>
      </div>
    </vs-popup>
    <!-- importing assignment modal-->

    <!-- <div v-if="isAssignmentModal">
        <vs-popup fullscreen title="" :active.sync="isAssignmentModal">
          <assignment-model
            :assignment_type_id="assignment_type_id"
            @getAssignmentData="importedAssignmentData"
          ></assignment-model>
        </vs-popup>
      </div> -->
    <div v-if="isAssignmentModal">
      <vs-popup fullscreen title="" :active.sync="isAssignmentModal">
        <!-- {{assignment_type_id}} -->

        <LessonModel
          @getAssignmentData="importedAssignmentData"
          v-if="assignment_type_id == 'lesson'"
          :subject_id="selectedSubjects"
        ></LessonModel>
        <assignment-model
          v-else
          :assignment_type_id="assignment_type_id"
          :subject_id="selectedSubjects"
          @getAssignmentData="importedAssignmentData"
        ></assignment-model>
      </vs-popup>
    </div>

    <!--  <div v-if="isAssignmentModal">
        <vs-popup fullscreen title="" :active.sync="isAssignmentModal">
          {{assignment_type_id}}
          <lesson-model
            @getLessonLists="importedAssignmentData"
          ></lesson-model>
        </vs-popup>
      </div> -->

    <!-- Importing Assignment Modal -->
  </div>
</template>

<script>
import Vue from 'vue'
import previewTemp from '../Testing/previewTemplate.vue'
import BasicDetailsEditModal from './components/BasicDetailsEditModal.vue'
import AssignedTeachersEditModal from './components/AssignedTeachersEditModal.vue'
import AssignedStudentsEditModal from './components/AssignedStudentsEditModal.vue'
import ScheduleSettings from './components/ScheduleSettings.vue'
import AssignmentModel from './components/AssignmentModel.vue'
import LessonModel from './components/LessonModel.vue'
import LessonListing from './components/LessonListing.vue'
import AssignmentList from './components/AssignmentList.vue'
import StudentAttendance from './components/attendance/StudentAttendance.vue'
import TeacherAttendance from './components/attendance/TeacherAttendance.vue'
import FileUploadComponent from './components/FileUploadComponent.vue'
import ChatSettings from './components/ChatSettings.vue'
import GradeSettings from './components/GradeSettings.vue'
import GradeListing from './components/GradeListing.vue'
import { repository } from '@/mixins/repository.js'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { AgGridVue } from 'ag-grid-vue'
import TeacherStudentDetailsNameCell from './table_components/TeacherStudentDetailsNameCell.vue'
import vSelect from 'vue-select'

import {
  getClassDetails,
  saveClassCurriculum,
  getCurricullum,
  createDuplicate,
  fetchClassTemp,
  saveCertificateSettings,
  deleteCurricullumApi
} from '@/api/classes'

export default {
  name: 'classDetails',
  mixins: [repository, PermissionMiddleware],
  components: {
    BasicDetailsEditModal,
    AssignedTeachersEditModal,
    AssignedStudentsEditModal,
    ScheduleSettings,
    AssignmentModel,
    AssignmentList,
    LessonModel,
    previewTemp,
    LessonListing,
    StudentAttendance,
    TeacherAttendance,
    FileUploadComponent,
    vSelect,
    GradeListing,
    ChatSettings,
    GradeSettings,
    AgGridVue,
    TeacherStudentDetailsNameCell
  },
  data () {
    return {
      gridOptions: {},
      gridOptions1: {},
      opened: [],
      template_list: false,
      customer_id: localStorage.getItem('customer_id'),
      classId: null,
      isArchived: null,
      basicDetails: null,
      selected_teachers_list: [],
      selected_students_list: [],
      details_to_edit: null,
      basicDetailsModalShow: false,
      assignedTeachersModalShow: false,
      assignedStudentsModalShow: false,
      isAssignmentModal: false,
      isLessonModal: false,
      assignment_type: 'homework',
      assignment_type_id: 2,
      assignment_data_list: [],
      classTempList: [],
      previewModal: false,
      tempDetails: [],
      uploadedFiles: [],
      files_info: [],
      platform_module_id: 49,
      previewSelectCerModal: false,
      SelectTempDetails: [],
      showClassCurriculumImport: true,
      selectedSubjects: [],
      chat_settings: false,
      selectedTeachersListColumnDefs: [
        {
          headerName: 'Full Name',
          field: 'full_name',
          cellRendererFramework: Vue.extend(TeacherStudentDetailsNameCell)
        },
        {
          headerName: 'Email',
          field: 'email'
        },
        {
          headerName: 'Phone Number',
          field: 'phone'
        },
        {
          headerName: 'Role Name',
          field: 'role_name'
        }
      ],
      selectedStudentsListColumnDefs: [
        {
          headerName: 'Full Name',
          field: 'full_name',
          cellRendererFramework: Vue.extend(TeacherStudentDetailsNameCell)
        },
        {
          headerName: 'Email',
          field: 'email'
        },
        {
          headerName: 'Phone Number',
          field: 'phone'
        },
        {
          headerName: 'User Type',
          field: 'user_type'
        },
        {
          headerName: 'Root User',
          field: 'root_user_name'
        }
      ]
    }
  },
  created () {
    this.classId = this.$route.params.class_id
    this.isArchived = this.$route.query.is_archived === 'true'
    this.accessCurricullumList(this.assignment_type)

    this.getClassDetails()
    this.fetchTemplateList()
    this.getRepositoryId(this.platform_module_id)

    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Class')
      this.getModulePermission('Grade')
      this.getModulePermission('Teachers')
    }
  },
  methods: {
    async updateCertificate () {
      if (this.basicDetails.certificate_template_id == null) {
        this.showSuccessMessage('Error', 'Please Choose a template', 'danger')
      } else {
        const payload = {
          class_id: this.classId,
          certificate_template_id: this.basicDetails.certificate_template_id,
          certificate_share_type: this.basicDetails.certificate_share_type
        }

        const data = await saveCertificateSettings(payload)

        this.showSuccessMessage('Success', 'Certificate settings changed successfully', 'success')
      }


    },
    handlePreview (data) {
      this.previewSelectCerModal = true
      this.SelectTempDetails = data
    },
    handleChange (data) {
      this.basicDetails.certificate_template_id = data.certificate_template_id
      this.basicDetails.class_certificate_template = data
    },
    preview (data) {
      this.previewModal = true
      this.tempDetails = data
      const index = this.opened.indexOf(data.certificate_template_id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [data.certificate_template_id]
      }
    },
    async fetchTemplateList () {
      try {
        const responseList = await fetchClassTemp(this.$store.getters.customerId)
        this.classTempList = responseList.data.data.certificate_template_list
      } catch (error) { }
    },
    async deleteCurricullum (ids) {
      try {
        const payload = {
          curriculum_ids: ids
        }
        const data = await deleteCurricullumApi(payload)
        this.accessCurricullumList(this.assignment_type)
        this.showSuccessMessage(
          'Success',
          'Curricullum Deleted Successfully',
          'success'
        )
      } catch (error) {
        console.warn(error)
      }
    },
    async importedAssignmentData (data) {
      const existing_ids = this.assignment_data_list.map(
        (ele) => ele.curriculum_details.id
      )
      try {
        const payload = {
          class_id: this.classId,
          curriculum_type: this.assignment_type,
          curriculum_ids: [...existing_ids, ...data.map((ele) => ele.id)]
        }
        const responseObject = await saveClassCurriculum(payload)
        this.accessCurricullumList(this.assignment_type)

        this.isAssignmentModal = false
      } catch (error) {
        console.warn(error)
      }
    },

    openImportAssignment () {
      this.isAssignmentModal = true
    },
    assignmentType (assignment_id = null) {
      this.showClassCurriculumImport = true

      if (assignment_id == 'homework') {
        this.assignment_type_id = 2
      } else if (assignment_id == 'report') {
        this.assignment_type_id = 3
      } else if (assignment_id == 'exam') {
        this.assignment_type_id = 4
      }
      if (assignment_id == 'lesson') {
        this.assignment_type_id = 'lesson'
      }
      this.assignment_type = assignment_id
      this.accessCurricullumList(assignment_id)
    },
    async accessCurricullumList (assignment_id) {
      this.assignment_data_list = []

      try {
        const payload = {
          class_id: this.classId,
          curriculum_type: assignment_id
        }
        const { data } = await getCurricullum(payload)
        this.assignment_data_list = data.data.class_curriculum_list
      } catch (error) {
        console.warn(error)
      }
    },
    async getUploadedFiles () {
      this.showClassCurriculumImport = false

      await this.accessCurricullumList('file')
      this.uploadedFiles = []
      this.files_info = this.assignment_data_list.map(file => {
        this.uploadedFiles.push(file.curriculum_details.files_id)
        return file.curriculum_details
      })
    },
    async getClassDetails (updatedData) {
      try {
        if (!updatedData) {
          const response = await getClassDetails(
            this.customer_id,
            this.classId
          )
          this.basicDetails = response.data.data.classes
        } else {
          this.basicDetails = updatedData
        }

        console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh", this.basicDetails)

        this.selected_teachers_list =
          this.basicDetails.teacher.teacher_details.map((item) => {
            return {
              id: item.id,
              first_name: item.first_name,
              middle_name: item.middle_name,
              last_name: item.last_name,
              email: item.email,
              phone: item.phone,
              role_name: item.role_name,
              picture: item.picture,
              full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
            }
          })

        this.selected_students_list =
          this.basicDetails.student.student_details.map((item) => {
            return {
              ...item,
              full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
            }
          })

        this.chat_settings = this.basicDetails.can_chat
      } catch (e) {
        console.log(e)
      }
    },
    async duplicateClassData () {
      try {
        const response = await createDuplicate({
          class_id: this.classId,
          customer_id: this.customer_id
        })
        this.showSuccessMessage('Success', response.data.message, 'success')
      } catch (e) {
        console.log(e)
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    openBasicDetailsEditModal () {
      this.basicDetailsModalShow = true
      this.details_to_edit = this.basicDetails
    },
    closeBasicDetailsEditModal () {
      this.basicDetailsModalShow = false
      this.details_to_edit = null
    },
    openAssignedTeachersEditModal () {
      this.assignedTeachersModalShow = true
      this.details_to_edit = this.basicDetails
    },
    closeAssignedTeachersEditModal () {
      this.assignedTeachersModalShow = false
      this.details_to_edit = null
    },
    openAssignedStudentsEditModal () {
      this.assignedStudentsModalShow = true
      this.details_to_edit = this.basicDetails
    },
    closeAssignedStudentsEditModal () {
      this.assignedStudentsModalShow = false
      this.details_to_edit = null
    },
    updateList (data) {
      this.getClassDetails(data)
    },
    getFileId (file_id) {
      this.uploadedFiles.push(file_id)
    },
    deleteUploadedFile (index) {
      this.uploadedFiles.splice(index, 1)
    },
    async saveFiles () {
      const payload = {
        class_id: this.classId,
        curriculum_type: 'file',
        curriculum_ids: this.uploadedFiles
      }

      try {
        const response = await saveClassCurriculum(payload)
        this.showSuccessMessage('Success', 'Files Saved Successfully', 'success')
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    allowedToEdit () {
      return this.checkEditPermission() && !this.isArchived
    },
    allowedToEditMarks () {
      return this.checkMarksEntryPermission() && !this.isArchived
    },
    allowedToEditGradeSettings () {
      return this.checkGradebookSettingsEditPermission() && !this.isArchived
    },
    allowedToDelete () {
      return this.checkDeletePermission() && !this.isArchived
    },
    subjectsSelected (subjects) {
      this.selectedSubjects = [...subjects]
    },
    updateChatSettings () {
      this.updateList()
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    onGridReady1 () {
      this.gridOptions1.api.sizeColumnsToFit()
    },
    showMore () {
      this.$refs.class_student_img_holder.$el.classList.add('shown')
    },
    showLess () {
      this.$refs.class_student_img_holder.$el.classList.remove('shown')
    }
  }
}
</script>

<style scoped>
.class_image_container {
  width: 200px;
  height: 200px;
}
.class_image {
  width: inherit;
}
</style>

<style lang="scss">
.opened {
  background: rgba(var(--vs-primary), 0.5);
  color: rgba(var(--vs-text), 1);
}

.class_setting_collapse .vs-collapse-item.open-item .vs-collapse-item--content {
  overflow: unset;
}

.class-detail-page {
  .class-name {
    position: absolute;
    top: -22px;
    left: 136px;
  }

  .other-info {
    margin-top: 20px;

    .con-ul-tabs {
      padding: 16px;
      background: white;
      border-radius: 0.5rem;
      box-shadow: 0px 4px 25px 0px #ededed;

      .vs-tabs--ul {
        box-shadow: unset;
      }
    }

    .vs-tabs--li {
      margin-right: 20px;

      &.activeChild .vs-tabs--btn {
        background: #3ac2d4;
        color: white !important;
        border-radius: 4px;
        padding: 10px 20px;

        &:hover {
          color: white !important;
        }
      }
    }

    .line-vs-tabs {
      display: none;
    }

    .vs-tabs--content {
      padding: 0;
      background: white;
    }

    .con-slot-tabs {
      margin-top: 24px;
      border-radius: 0.5rem;
    }
  }

  .main-info {
    margin-top: 20px;
    padding: 10px 0;
    background: #f3feff;
    border: 1px solid #c6c6c6;
    border-radius: 0px 0px 5px 5px;

    & > div {
      border-left: 1px solid #c6c6c6;
    }

    & > div:first-child {
      border-width: 0;
    }

    .main-info-item-image {
      width: 30px;
      height: 30px;
      border: 1px solid white;
      border-radius: 50%;
      margin-right: 10px;
    }

    .overlap-image {
      position: absolute;
    }

    .main-info-item-icon {
      margin-right: 10px;
      color: #555262;
    }

    .main-info-item-text {
      display: flex;
      flex-direction: column;
      color: #555262;

      .first-line {
        font-size: 15px;
        font-weight: 600;
      }

      .second-line {
        font-size: 14px;
      }
    }
  }
}
</style>
